import crossIcon from 'assets/icons/cross-icon.svg'
import './filterMenu.scss'

interface FilterMenuProps {
  onClose?: () => void
  onApply: () => void
  onClear: () => void
  children: React.ReactNode
}

export default function FilterMenu({ onClose, onApply, onClear, children }: FilterMenuProps) {
  return (
    <div className="filter-popover">
      <div className="filter-popover-header">
        <span className="title">Filters</span>
        <img src={crossIcon} alt="close" className="close-icon" onClick={onClose} />
      </div>

      <div className="fields-wrapper">
        {children}
      </div>

      <div className="filter-popover-actions">
        <button className="apply" onClick={() => {
          onApply()
          onClose?.()
        }}>Apply Filter</button>
        <button className="clear" onClick={onClear}>Clear Filter</button>
      </div>
    </div>
  )
}

